var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SafeVerifyModal',{attrs:{"smstype":16},on:{"on-ok":_vm.confirmHandle},model:{value:(_vm.modalVis.mentionMoneyVerifyModal),callback:function ($$v) {_vm.$set(_vm.modalVis, "mentionMoneyVerifyModal", $$v)},expression:"modalVis.mentionMoneyVerifyModal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }